import { runInAction } from 'mobx';
import { updateFetchedData } from './update-fetched-data';
/**
 * A MobX runInAction wrapper around [[updateFetchedData]], used for observable [[FetchedData]] values.
 */
export const updateFetchedDataState = (state, newValue) => {
    runInAction(() => updateFetchedData(state, newValue));
};
//# sourceMappingURL=update-fetched-data-state.js.map